export default __webpack_public_path__ + "static/header-82bb33869c89e28321dd58759f0b17ba.jpg";